import { Address, beginCell, SenderArguments } from "@ton/core";
import {
  SendTransactionRequest,
  TonConnect,
  TonConnectUI,
  UserRejectsError,
  WalletInfo,
  WalletInfoInjectable,
} from "@tonconnect/ui-react";
// import { isMobile, openLink } from "../methods/auth/utils";
import { StateInit, storeStateInit } from "@ton/ton";
// import LockerStore from "../store/Locker/LockerStore"
import TonWeb from "tonweb";

export interface ISender {
  readonly address?: Address;
  connector: TonConnect;
  send(args: SenderArguments): Promise<void>;
  sendTransaction(
    tx: SendTransactionRequest,
    wallet: WalletInfo
  ): Promise<{ boc: string }>;
}

export class Sender implements ISender {
  readonly address: Address | undefined;
  connector: TonConnect;
  constructor(tonConnectUI: TonConnectUI) {
    this.connector = tonConnectUI.connector as TonConnect;
    this.address = tonConnectUI.account
      ? Address.parse(tonConnectUI.account.address)
      : undefined;
  }

  async send(args: SenderArguments): Promise<void> {
    const stateInit: StateInit = {
      code: args.init?.code,
      data: args.init?.data,
    };
    const stateInitCell = beginCell()
      .store(storeStateInit(stateInit))
      .endCell();
    let state_init_boc = TonWeb.utils.bytesToBase64(
      await stateInitCell.toBoc()
    );
    this.connector.sendTransaction({
      messages: [
        {
          address: args.to.toString(),
          amount: args.value.toString(),
          payload: args.body?.toBoc().toString("base64"),
          stateInit: state_init_boc,
        },
      ],
      validUntil: Date.now() + 5 * 60 * 1000,
    });
  }

  async sendTransaction(
    tx: SendTransactionRequest,
    wallet: WalletInfo
  ): Promise<{ boc: string }> {
    try {
      if (
        "universalLink" in wallet &&
        !(wallet as WalletInfoInjectable).embedded
      ) {
        // openLink(addReturnStrategy(wallet.universalLink, 'none'), '_blank');
      }

      const result = await this.connector.sendTransaction(tx);
      // notification.success({
      //   message: "Successful transaction",
      //   description:
      //     "You transaction was successfully sent. Please wait until the transaction is included to the TON blockchain.",
      //   duration: 5,
      // });
      console.log(`Send tx result: ${JSON.stringify(result)}`);
      return result;
    } catch (e) {
      let message = "Send transaction error";
      let description = "";

      if (typeof e === "object" && e instanceof UserRejectsError) {
        message = "You rejected the transaction";
        description =
          "Please try again and confirm transaction in your wallet.";
      }

      // notification.error({
      //   message,
      //   description,
      // });
      console.log(e);
      throw e;
    }
  }
}

function addReturnStrategy(
  url: string,
  returnStrategy: "back" | "none"
): string {
  const link = new URL(url);
  link.searchParams.append("ret", returnStrategy);
  return link.toString();
}
